/**
 * Category icons, copied from the reference's own `CATEGORIES` constant (grep
 * `CATEGORIES = [` in
 * `resources/Dental supply storefront design system/Dens N Dente Tailwind.dc.html`).
 * Consumed by the navbar's category mega-menu (`ProductsDropdown`) and the categories
 * landing page (`pages/CategoriesPage.jsx`) — one table, so the same category can't show
 * two different icons.
 *
 * **Keyed by classification id, not by name.** Verified against the live API: the
 * reference's 22 categories and the 22 NetSuite top-level classifications that have
 * children match **22/22 on both id and name**, so either key works today — but an id
 * survives a rename and a name doesn't.
 *
 * This replaced `CATEGORY_ICONS[index % 8]`, which assigned icons by **position** in the
 * list. That was wrong twice over: only about 3 of 22 happened to suit their category
 * (BURS got `masks`, Endodontics got `cleaning_services`), and because the list is
 * `ORDER BY name ASC`, adding or renaming one category silently reshuffled every icon
 * after it.
 *
 * NetSuite's `classification` table has no icon column — it returns `id / name / parent`
 * only — so this table is the only place the pairing exists. A category the reference
 * doesn't know about falls back to `category`, which is what the reference itself uses
 * for its catch-all "Other".
 */
export const CATEGORY_ICON_BY_ID = {
  1: "layers", // Alloys
  2: "vaccines", // Anesthetics
  3: "diamond", // BURS
  4: "dentistry", // Crowns & Bridges
  5: "colorize", // Cements & Liners
  6: "healing", // Endodontics
  7: "construction", // Equipment
  10: "redeem", // Gift
  11: "sanitizer", // Infection Control
  12: "science", // Impression Materials
  13: "precision_manufacturing", // Instruments
  15: "straighten", // Orthodontics
  16: "medication", // Preventatives
  17: "format_paint", // Restoratives
  30: "crop_free", // Matrix Systems
  85: "radiology", // X-Ray
  95: "edit_note", // Office Supplies
  107: "category", // Other
  121: "biotech", // Lab
  126: "auto_awesome", // Whitening
  155: "medication_liquid", // IV Products
  161: "shopping_bag", // E-Commerce
};

export const FALLBACK_CATEGORY_ICON = "category";

export const categoryIcon = (id) =>
  CATEGORY_ICON_BY_ID[id] ?? FALLBACK_CATEGORY_ICON;
